import { defineMessages } from 'react-intl';

export const contractTypesTranslations = defineMessages({
    fixedTerm: {
        id: 'DeveloperProfile.contractTypes.fixedTerm',
        defaultMessage: 'Fixed-Term'
    },
    permanent: {
        id: 'DeveloperProfile.contractTypes.permanent',
        defaultMessage: 'Permanent'
    },
    internship: {
        id: 'DeveloperProfile.contractTypes.internship',
        defaultMessage: 'Internship'
    },
    apprenticeship: {
        id: 'DeveloperProfile.contractTypes.apprenticeship',
        defaultMessage: 'Apprenticeship'
    },
    freelance: {
        id: 'DeveloperProfile.contractTypes.freelance',
        defaultMessage: 'Freelancing'
    },
    unknown: {
        id: 'DeveloperProfile.contractTypes.unknown',
        defaultMessage: 'Unknown'
    }
});
